<!-- 预售专区 -->
<template>
  <cc-container class="pre-order">
    <!-- 搜索框 -->
    <!-- <cc-header-nav title="预售订单" url="/user/index?goback=1"> -->
    <cc-header-nav title="预售订单" url="/#/management">
      <cc-svg-icon @click="showDatePicker" size="20px" slot="right" icon-class="calendar"></cc-svg-icon>
    </cc-header-nav>
    <cc-fade>
      <div style="position:relative;">
        <cc-date-filter
          v-show="dateFilterVisible"
          @search="handleDateFilter"
          @cancel="emptyData"
          ref="dateFilter"
        ></cc-date-filter>
      </div>
    </cc-fade>
    <div class="search-box" style="border-bottom:5px solid #eeeeee;">
      <input
        v-model="order_number"
        class="input-search"
        type="text"
        placeholder="订单号搜索"
        @keyup.13="search()"
      />
      <cc-svg-icon
        size=".16rem"
        @click="order_number = ''"
        class-name="search-icon"
        :icon-class="iconVisible?'cancel':'search'"
      ></cc-svg-icon>
    </div>
    <!-- 内容部分 -->
    <cc-main>
      <van-tabs @click="handleTabClick" color="#1BB0D9" v-model="active" :line-height="1">
        <van-tab title="全部"></van-tab>
        <van-tab title="定金待付"></van-tab>
        <van-tab title="尾款待付"></van-tab>
        <van-tab title="待收货"></van-tab>
        <van-tab title="已完成"></van-tab>
        <van-tab title="已取消"></van-tab>
      </van-tabs>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          class="order-list"
          v-model="m_loading"
          :finished="m_finished"
          :finished-text="m_finishedText"
          @load="mHandlePullUpLoadMore"
          :immediate-check="m_immediateCheck"
        >
          <cc-not-order v-if="list.length === 0 && m_loading === false" tip="亲，暂无相关预售单哦"></cc-not-order>
          <!-- <cc-animation-list> -->
          <div class="order-item" v-for="item in list" :key="item.id" v-else>
            <router-link :to="`/presell/order/detail/${item.order_number}`" tag="section">
              <div class="order-top">
                <p>订单号：{{item.order_number}}</p>
                <p style="color: #F53737;">{{item.order_state_name}}</p>
              </div>
              <div class="order-middle">
                <div class="order-img-list">
                  <img class="order-img" v-lazy="item.image" />
                  <i class="order-tips">共{{item.quantity}}件</i>
                </div>
              </div>
            </router-link>
            <div class="order-deposit" style="border-bottom:1px solid #E5E5E5;">
              <span>
                定金：
                <span class="price">￥{{item.deposit}}</span>
                <span v-if="item.deposit_payment_date*1>0">（已完成）</span>
                <span v-else>（未完成）</span>
              </span>
              <span
                class="depositBtn"
                v-if="item.order_state==12"
                @click="payMoney(item.order_number)"
              >支付定金</span>
              <span
                class="depositBtn"
                v-if="item.order_state==1&&item.payment_type==0"
                @click="confirmGoods(item.order_number)"
              >确认收货</span>
            </div>
            <div class="order-deposit" v-if="item.payment_type==1">
              <span>
                尾款：
                <span class="price">￥{{item.last_amout}}</span>
                <span v-if="item.final_payment_date*1>0">（已完成）</span>
                <span v-else>（未完成）</span>
              </span>
              <!-- 要到了尾款支付时间才能显示支付尾款按键，否则只是显示尾款支付时间 -->
              <span
                class="depositBtn"
                v-if="item.order_state==1"
                @click="confirmGoods(item.order_number)"
              >确认收货</span>
              <span
                v-if="item.order_state==13&&item.now_time>=item.payment_start_time_stamp*1&&item.final_payment_date*1==0"
                class="depositBtn"
                @click="payMoney(item.order_number)"
              >支付尾款</span>
              <span
                v-else-if="item.order_state==13&&item.now_time<item.payment_start_time_stamp*1"
              >{{item.payment_start_time}}开始支付尾款</span>
            </div>
          </div>
          <!-- </cc-animation-list> -->
        </van-list>
      </van-pull-refresh>
    </cc-main>
    <!-- 底部 -->
    <cc-footer>
      <cc-nav></cc-nav>
    </cc-footer>
  </cc-container>
</template>
<script>
import Vue from 'vue'
import { Lazyload, List, Tab, Tabs, Dialog, PullRefresh } from 'vant'
import ListMixin from '@/mixins/list'
import { ResultCode } from '~const/ResultCode'
import { loadPresellOrderList, orderOk } from '../../../fetch/pre-sell'
Vue.use(Lazyload)
  .use(List)
  .use(Tab)
  .use(Tabs)
  .use(Dialog)
  .use(PullRefresh)
export default {
  name: 'presell-order',
  mixins: [ListMixin],
  data () {
    return {
      // 搜索清除图标的显示隐藏
      iconVisible: false,
      // 下拉刷新开关
      isLoading: false,
      // 日期组件的显示隐藏
      dateFilterVisible: false,
      // 订单号
      order_number: '',
      // tab切换
      active: 0,
      // 预售订单数据
      list: [],
      // 订单状态
      state: 0
    }
  },
  watch: {
    order_number () {
      this.order_number.length > 0
        ? (this.iconVisible = true)
        : (this.iconVisible = false)
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /**
     * @description 上拉刷新
     */
    onRefresh () {
      setTimeout(() => {
        this.$toast('刷新成功')
        this.isLoading = false
        this.m_page.curr = 1
        this.list = []
        this.loadData()
      }, 500)
    },
    /**
     * @description 加载数据
     */
    async loadData (reset) {
      // 先清空原有的数据再加载
      if (reset) {
        this.list = []
      }
      this.mRequest()
      var params = {
        page: this.m_page.curr,
        limit: this.m_page.limit,
        order_number: this.order_number,
        start_date: this.start_time,
        end_date: this.end_time,
        order_state: this.state
      }
      let { data, status } = await loadPresellOrderList(params)
      if (status === ResultCode.SUCCESS) {
        if (data.order_data.length === 0) {
          // 全部数据加载完成
          this.m_finishedText = ''
          this.mEnd()
        } else {
          this.list = [...this.list, ...data.order_data]
          if (data.order_data.length < 10) {
            this.m_finishedText = '已全部加载完成'
            this.mEnd()
          }
        }
        this.mSuccess()
      } else {
        this.mEnd()
      }
    },
    showDatePicker () {
      this.dateFilterVisible = ~this.dateFilterVisible
    },
    emptyData ({ startDate, endDate }) {
      // 父组件改变子组件的值
      this.$refs.dateFilter.startDate = ''
      this.$refs.dateFilter.endDate = ''
    },
    /**
     * @description 根据订单号搜索
     */
    search () {
      this.mReset()
      const reset = true
      this.loadData(reset)
    },
    /**
     * @description 根据时间搜索
     */
    handleDateFilter ({ startDate, endDate }) {
      this.start_time = startDate
      this.end_time = endDate
      this.search()
      this.dateFilterVisible = false
    },
    /**
     * @description 确认收货
     */
    confirmGoods (id) {
      Dialog.confirm({
        message: '是否确定收货？'
      })
        .then(async () => {
          let res = await orderOk({
            order_number: id
          })
          if (res.state === 0) {
            this.list.forEach(item => {
              if (item.order_number === id) {
                item.order_state = 4
                item.order_state_name = '已完成'
              }
            })
          }
        })
        .catch(() => {
          // on cancel
        })
    },
    /**
     * @description 订单状态切换时
     */
    handleTabClick (index, title) {
      const stateMap = {
        全部: 0,
        待收货: 1,
        已取消: 3,
        已完成: 4,
        定金待付: 12,
        尾款待付: 13
      }
      this.state = stateMap[title]
      this.search()
    },
    /**
     * @description 支付定金
     */
    payMoney (id) {
      window.location = '/order/success/?order_number=' + id
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~styles/index.scss";
.pre-order {
  background: #fff;
  .search-box {
    height: 40px;
    position: relative;
    @include center(column);
    .input-search {
      height: 28px;
      width: 91%;
      border-radius: 2px;
      border: 1px solid $border-color-base;
      padding-left: 10px;
      font-size: 12px;
    }
    .search-icon {
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto 0;
      right: 20px;
    }
  }
  .order {
    &-list {
      @include flex(column);
    }
    &-item {
      box-sizing: border-box;
      padding: 10px 10px 0 10px;
      border: 1px solid $border-color-base;
      border-left: 0;
      border-right: 0;
      box-shadow: $box-shadow-base;
      margin-bottom: 8px;
    }
    &-top {
      @include flex(row);
      padding-bottom: 12px;
      border-bottom: 1px solid $border-color-base;
      justify-content: space-between;
      font-size: 12px;
      color: $heading-color;
      font-weight: 700;
      .price {
        color: #eb1f1f;
        font-weight: 700;
      }
    }
    &-middle {
      padding: 15px 0;
      border-bottom: 1px solid $border-color-base;
      @include flex(row);
      align-items: center;
      .order-tips {
        width: 60px;
        height: 60px;
        background: #eeeeee;
        color: #777777;
        font-size: 12px;
        float: right;

        @include center(row);
      }
    }
    &-bottom {
      padding-top: 10px;
      font-size: 11px;

      @include flex(row);
      justify-content: space-between;
      align-items: center;
      > p:first-child {
        // width: 150px;
        flex: 1;
        box-sizing: border-box;
      }
      > p:nth-child(2) {
        // flex: 1;
        text-align: left;
      }
    }
    &-img {
      width: 60px;
      height: 60px;
      border: 1px solid $border-color-base;
      margin-right: 25px;
      &-list {
        width: 100%;
      }
    }
    &-deposit {
      // border-bottom:1px solid #E5E5E5;
      height: 35px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      color: #777777;
      line-height: 35px;
      .price {
        color: #f53737;
      }
      .depositBtn {
        height: 28px;
        width: 75px;
        background: var(--APP_theme_color);
        color: #ffffff;
        display: inline-block;
        text-align: center;
        line-height: 28px;
      }
      .finishBug {
        background: #f7f7f7;
        color: #999999;
        width: 75px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        font-size: 12px;
        border: 1px solid #d2d2d2;
      }
    }
  }
}
</style>
